module.exports = __webpack_public_path__ + "static/media/image-card-3.113cbec3.png";